import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useRef } from "react";
import { getOffersBootstrap } from "@/app/actions/offer/bootstrap/action";
import { OffersBootstrap } from "@/app/types/offer/OffersBootstrap";
import { QueryKey } from "@/app/vars/QueryKeys";

type Options = {
  projectId?: number;
  enabled?: boolean;
  initialData?: OffersBootstrap;
};

export function useFetchOffersBootstrap(options: Options) {
  const { projectId, enabled = true, initialData } = options;
  const queryClient = useQueryClient();

  const seedCaches = (bootstrap: OffersBootstrap) => {
    queryClient.setQueryData([QueryKey.PROJECT_OFFER, projectId], bootstrap.offers);
    queryClient.setQueryData([QueryKey.HAS_PROJECT_INSIGHTS, projectId], bootstrap.hasInsights);
  };

  const seededProjectId = useRef<number | undefined>(undefined);
  if (initialData && projectId && seededProjectId.current !== projectId) {
    seedCaches(initialData);
    seededProjectId.current = projectId;
  }

  return useQuery({
    queryKey: [QueryKey.OFFERS_BOOTSTRAP, projectId],
    queryFn: async () => {
      const bootstrap = await getOffersBootstrap(projectId!);
      seedCaches(bootstrap);

      return bootstrap;
    },
    enabled: enabled && !!projectId,
    staleTime: Infinity,
    initialData: seededProjectId.current === projectId ? initialData : undefined,
  });
}
